import React, { useState } from 'react';
import { userSettingsAPI } from '../../services/api';
import './SettingsPage.css';

function ProfileImage() {
  const [uploading, setUploading] = useState(false);
  const [message, setMessage] = useState({ type: '', text: '' });
  const [preview, setPreview] = useState(null);

  const handleFileSelect = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // Validate file type
    if (!file.type.startsWith('image/')) {
      setMessage({ type: 'error', text: 'Please select an image file' });
      return;
    }

    // Validate file size (max 5MB)
    if (file.size > 5 * 1024 * 1024) {
      setMessage({ type: 'error', text: 'Image size must be less than 5MB' });
      return;
    }

    // Show preview
    const reader = new FileReader();
    reader.onload = (e) => setPreview(e.target.result);
    reader.readAsDataURL(file);

    // Upload
    try {
      setUploading(true);
      setMessage({ type: '', text: '' });
      await userSettingsAPI.uploadProfileImage(file);
      setMessage({ type: 'success', text: 'Profile image uploaded successfully!' });
    } catch (error) {
      setMessage({
        type: 'error',
        text: error.response?.data?.message || 'Failed to upload image',
      });
      setPreview(null);
    } finally {
      setUploading(false);
    }
  };

  const handleDelete = async () => {
    if (!window.confirm('Are you sure you want to delete your profile image?')) {
      return;
    }

    try {
      await userSettingsAPI.deleteProfileImage();
      setPreview(null);
      setMessage({ type: 'success', text: 'Profile image deleted successfully!' });
    } catch (error) {
      setMessage({
        type: 'error',
        text: error.response?.data?.message || 'Failed to delete image',
      });
    }
  };

  return (
    <div className="settings-page-content">
      <h2>Profile Image</h2>
      <p className="page-description">Upload or change your profile picture.</p>

      {message.text && (
        <div className={`message ${message.type}`}>{message.text}</div>
      )}

      <div className="form-section">
        <div style={{ textAlign: 'center' }}>
          <div style={{
            width: '200px',
            height: '200px',
            margin: '0 auto 20px',
            border: '2px dashed #ddd',
            borderRadius: '50%',
            overflow: 'hidden',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: '#f8f9fa',
          }}>
            {preview ? (
              <img src={preview} alt="Profile" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
            ) : (
              <span style={{ fontSize: '64px' }}>👤</span>
            )}
          </div>

          <div style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
            <label className="btn btn-primary" style={{ cursor: 'pointer' }}>
              {uploading ? 'Uploading...' : 'Choose Image'}
              <input
                type="file"
                accept="image/*"
                onChange={handleFileSelect}
                disabled={uploading}
                style={{ display: 'none' }}
              />
            </label>
            {preview && (
              <button onClick={handleDelete} className="btn btn-danger">
                Delete Image
              </button>
            )}
          </div>
        </div>
      </div>

      <div className="info-box">
        <p>
          <strong>Image requirements:</strong>
          <br />
          • Maximum file size: 5MB
          <br />
          • Accepted formats: JPG, PNG, GIF
          <br />• Recommended: Square image, at least 400x400 pixels
        </p>
      </div>
    </div>
  );
}

export default ProfileImage;
